function EidReservation() {
    "use strict";
    this.__type = 'EidReservation:www.veritracks.com';
    this.Id = -1;
    this.EnrolleeId = -1
    this.StatusId = -1;
    this.UserId = -1;
    this.EidTypeId = -1;
    this.StartDate = new Date();
    this.EndDate = new Date();

    /*
    
    <DataMember()>
    Public Property Status As EidStatusEnum = EidStatusEnum.Unknown

    <DataMember()>
    Public Property EnrolleeId As Long = -1

    <DataMember()>
    Public Property ReservedDateUTC As DateTime

    <DataMember()>
    Public Property CanceledDateUTC As DateTime

    <DataMember()>
    Public Property ExpirationDateUTC As DateTime

    <DataMember()>
    Public Property StartDateUTC As DateTime

    <DataMember()>
    Public Property EndDateUTC As DateTime
End Class
    */
}
if (typeof exports !== 'undefined') {
    module.exports = EidReservation;
}